import React from "react";

import "./DepositSvgStyles.scss";

function RightArrow() {
    return (
        <div className="svg-content">
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="icon-right" d="M1 1L8 8L1 15" stroke="#222222" strokeWidth="1.5"/>
            </svg>
        </div>
    );
}

export default RightArrow;
